<template>
  <div class="save-info-container">
    <img :src="backgroundImage" alt="">
    <div class="save-info-form">
      <van-field
        label="介绍人"
      >
        <template #button>
          <div>
            {{form.userName}}
          </div>
        </template>
      </van-field>
      <van-field

        type="tel"
        label="资格认定"
        placeholder=""
      >
      <template #button>
        <div style=" display:flex;align-items: center">
          <span style="margin-right: 10px">{{ is_qualification ? "您有介绍人资格" : "您无介绍人资格" }}</span>
          <van-icon name="info-o" size="15"  @click="showTip = true"/>
        </div>
      </template>
      </van-field>
      <van-field
        v-model="form.introducedName"
        label="被介绍人姓名"
        input-align="right"
        placeholder="请填写您的姓名"
      />
      <van-field
        v-model="form.introducedPhone"
        label="被介绍人手机号"
        input-align="right"
        placeholder="请填写您的手机号"
      />
      <van-field
        v-model="form.carModel"
        is-link
        readonly
        label="欲购车车型"
        input-align="right"
        placeholder="请选择欲购车车型"
        @click="showCarType = true"
      />
      <van-field
        v-model="form.fieldValue"
        is-link
        readonly
        label="意向区域"
        input-align="right"
        placeholder="请选择意向区域"
        @click="showCityTree = true"
      />
      <van-field
        readonly
        is-link
        label="意向经销商"
        input-align="right"
        v-model="form.dealerName"
        placeholder="请选择意向经销商"
        @click="showDealer"
      />
      <div class="order-btn" @click="handleOrder_2">
        确定
      </div>
    </div>
    <van-popup
      v-model="showTip"
      round
      position="center"
      :style="{ width: '150px', height:'150px', padding: '20px' }"
      :close-on-click-overlay="true"
    >
      <div class="qualification-content">
        <p style="margin-bottom: 15px; line-height: 1.6; ">
          江淮卡友APP绑车用户均具有转介绍资格
        </p>
        <p>
          若您还未绑车，去绑车即可
        </p>
      </div>

    </van-popup>
    <van-popup v-model="showCityTree" round position="bottom"  >
      <van-cascader
        v-model="cascaderValue"
        title="请选择意向区域"
        :options="cityTree"
        :field-names="{
          text: 'cityName',
          value: 'cityNumber',
          children: 'children'
        }"
        @close="showCityTree = false"
        @finish="handleCitySelected"
      />
    </van-popup>
    <van-popup v-model="showCarType" round position="bottom" :style="{ height: '50%' }">
      <van-cascader
        v-model="cascadercarModel"
        title="请选择车型"
        :options="carTypeTree"
        :field-names="fieldNames"
        @close="showCarType = false"
        @finish="onCarTypeSelected"
        @change="onCascaderChange"
      />
    </van-popup>
    <van-popup v-model="showDealerList" round position="bottom">
      <van-picker
        show-toolbar
        :columns="filterDealer"
        @cancel="showDealerList = false"
        @confirm="handleDealerSelected"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import {
  getCityTree2, getDealerList, getBrandDict, qualification, add, getCarModelByBrandId
} from '@/api'
import pca from '@/assets/pca'

export default {
  name: 'DiscountedBuyCar',
  props: {
    backgroundImage: {
      type: String,
      default: ''
    },
    actiLargePostId: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    activitySource: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cityLocation: pca.pca,
      form: {
        userName: null, // 介绍人name
        userId: null, // 介绍人Id
        introducedName: null, // 被介绍人名称
        introducedPhone: null, // 被介绍人手机
        fieldValue: null, // 意向区域
        brand: null, // 品牌
        series: null, // 车系
        carModel: null, // 车型
        dealerName: null,
        carModelCode: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null
      },
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'children'
      },
      carTypeTree: [], // 三级树形数据
      brandList: [], // 品牌列表缓存
      seriesMap: new Map(), // 车系列表缓存
      is_qualification: false,
      countDown: false,
      countNumber: 60,
      cascaderValue: null,
      cascadercarModel: [],
      cityTree: [],
      carModel: [],
      brands: [
        {
          name: '皮卡',
          code: 'QK005'
        },
        {
          name: '德沃斯',
          code: 'QK011'
        },
        {
          name: '工程车',
          code: 'QK006'
        },
        {
          name: '骏铃',
          code: 'QK002'
        },
        {
          name: '恺达',
          code: 'QK010'
        },
        {
          name: '康铃',
          code: 'QK001'
        },
        {
          name: '帅铃',
          code: 'QK003'
        }
      ],
      showTip: false,
      showCityTree: false,
      showCarType: false,
      showDealerList: false,
      showCarList: false,
      columns: [],
      filterDealer: [],
      dealerList: [],
      lat: '',
      lon: '',
      carList: [],
      imgBaseData: null,
      carModelSelect: null,

      pictureCodeSessionId: ''
    }
  },
  methods: {
    // 初始化品牌数据
    initBrandData() {
      getBrandDict().then((res) => {
        this.brandList = res.data
        this.carTypeTree = res.data.map((brand) => ({
          id: brand.id,
          name: brand.name,
          children: [] // 先初始化空children
        }))
      })
    },
    onCascaderChange({ value }) {
      this.loadSeries(value)
    },
    // 加载车系数据
    loadSeries(brandId) {
      if (this.seriesMap.has(brandId)) return
      // 查询指定品牌的所有车型
      getCarModelByBrandId({ brandId }).then((res) => {
        const seriesData = res.data.map((series) => ({
          id: series.seriesId,
          name: series.seriesName,
          children: series.modelList.map((model) => ({
            id: model.modelId,
            name: model.modelName,
            rawData: model // 保留完整模型数据
          }))
        }))

        this.seriesMap.set(brandId, seriesData)

        // 更新树形数据
        const brandIndex = this.carTypeTree.findIndex((b) => b.id === brandId)
        if (brandIndex > -1) {
          this.$set(this.carTypeTree[brandIndex], 'children', seriesData)
        }
      })
    },

    // 选择完成回调
    onCarTypeSelected({ selectedOptions }) {
      if (selectedOptions.length === 3) {
        const [brand, series, model] = selectedOptions
        // this.form.carModel = `${brand.name}/${series.name}/${model.name}`
        this.form.brand = brand.name
        this.form.series = series.name
        this.form.carModel = model.name
        this.form.selectedModel = model.rawData

        console.log('选中车型详情:', model.rawData)
        // 可以访问 model.rawData 中的所有字段：
        // modelId, modelName, officialPrice 等
      }
      this.showCarType = false
    },
    // 转介绍
    getQualification() {
      console.log('@@@@')
      const { userId, userName } = this.$route.query
      this.form.userId = userId
      this.form.userName = userName
      console.log(userName, 'userNameNameNameName')
      // if (!userId) {
      //   return
      // }
      qualification({ userId })
        .then((res) => {
          this.is_qualification = res.data.data
          console.log(this.is_qualification, 'this.is_qualification')
        })
        .catch((err) => {
          this.$toast(err.message)
        })
    },
    onChange({ selectedOptions }) {
      this.carModelSelect = selectedOptions
    },

    setCountDown() {
      function sleep(interval) {
        return new Promise((resolve) => {
          setTimeout(resolve, interval)
        })
      }
      (async () => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 60; i++) {
          // eslint-disable-next-line no-plusplus
          this.countNumber--
          // eslint-disable-next-line no-await-in-loop
          await sleep(1000)
        }
        this.countDown = false
        this.countNumber = 60
      })()
    },
    // eslint-disable-next-line consistent-return
    showDealer() {
      const { carModel, fieldValue } = this.form
      if (!carModel) {
        return Toast('请选择意向车型')
      }
      if (!fieldValue) {
        return Toast('请选择意向区域')
      }
      // const car = this.carList.find((v) => v.name === carModel)
      const params = {
        pageNum: 1,
        pageSize: 1000,
        modelId: this.form.carModelCode

      }
      getDealerList(params, { lat: this.lat, lon: this.lon })
        .then((res) => {
          this.dealerList = res.data.list
          if (res.data.list && this.dealerList.length) {
            this.showDealerList = true
            this.filterDealer = res.data.list.map((v) => v.dealerName)
          } else {
            Toast('暂无经销商')
          }
        })
    },
    handleCitySelected({ selectedOptions }) {
      this.form.provinceId = selectedOptions[0].cityNumber
      this.form.provinceName = selectedOptions[0].cityName
      this.form.cityId = selectedOptions[1].cityNumber
      this.form.cityName = selectedOptions[1].cityName
      const province = this.cityLocation.find((v) => v.value === this.form.provinceId)
      const city = province.children.find((v) => v.value === this.form.cityId)
      this.lat = city.extra.lat
      this.lon = city.extra.lob
      this.showCityTree = false
      this.form.fieldValue = selectedOptions.map((option) => option.cityName).join('/')
      this.form.dealerName = null
      this.form.dealer = null
    },
    handleDealerSelected(val) {
      this.form.dealerName = val
      this.form.dealer = this.dealerList.find((v) => v.dealer_name === val)
      this.showDealerList = false
    },
    handleCarTypeSelected(v) {
      this.showCarType = false
      // eslint-disable-next-line prefer-destructuring
      // this.form.carSeriesCode = value[0]
      // eslint-disable-next-line prefer-destructuring
      this.form.carModelCode = v.value

      console.log(this.form.carModelCode, '7777777777')
      // this.form.carModel = selectedOptions.join('/')
      // this.form.dealerName = null
      // this.form.dealer = null
      this.form.carModel = v.text
    },
    handleCarSelected(val) {
      this.form.carModel = val
      this.showCarList = false
    },
    // eslint-disable-next-line consistent-return
    handleOrder_2() {
      const {
        introducedName, introducedPhone, carModel, fieldValue, dealerName
      } = this.form
      if (!introducedName) {
        return Toast('请输入被介绍人姓名')
      }
      if (!introducedPhone) {
        return Toast('请输入被介绍人手机号')
      }
      if (!carModel) {
        return Toast('请选择欲购车车型')
      }
      if (!fieldValue) {
        return Toast('请选择所属区域')
      }
      if (!dealerName) {
        return Toast('请选择经销商')
      }

      if (!(/^1[3456789]\d{9}$/.test(introducedPhone))) {
        Toast('请输入正确手机号')
      }
      const dealer = this.dealerList.find((v) => v.dealerName === dealerName)
        const params = {
          userId: Number(this.form.userId), // 介绍人Id
          introducedName: this.form.introducedName, // 被介绍人名称
          introducedPhone: this.form.introducedPhone, // 被介绍人手机
          fieldValue: this.form.fieldValue, // 意向区域
          dealer: this.form.dealerName, // 经销商名称
          dealerCode: dealer.id, // 经销商编号
          carBrand: this.form.brand, // 品牌
          carServies: this.form.series, // 车系
          carModel: this.form.carModel // 车型
        }
      add(params)
        .then((res) => {
          if (res.data.resultCode === 200) {
            // this.$toast('介绍卡友买车成功')
            Toast('介绍卡友买车成功')
          }
        })
        .catch((err) => {
          // this.$toast(err.message)
          Toast(err.message)
        })
    }
  },
  created() {
    this.initBrandData()
    this.getQualification()
    getCityTree2()
      .then((res) => {
        this.cityTree = res.data
      })
      .catch((err) => console.log(err.message))
    getBrandDict()
      .then((res) => {
        this.carModel = res.data.map((item) => ({
          text: item.name,
          value: item.id
        }))
        console.log(this.carModel, '99999999999')
      })
    // const pictureCodeSessionId = sessionStorage.getItem('pictureCodeSessionId')
    // if (!pictureCodeSessionId) {
    //   this.getPictureSessionIdFun()
    // } else {
    //   this.pictureCodeSessionId = pictureCodeSessionId
    // }
  }
}
</script>

<style scoped lang="scss">
.qualification-content {
  font-size: 15px;
  color: #333;
  padding: 10px 5px;
}

.save-info-container{

  position: relative;
  img{
    width: 100%;
    display: block;
  }
  .save-info-form{
    position: absolute;
    top: 0;
    //background-color: #ffefd8;
    //padding-top:rem(50);
    //padding-bottom:rem(50);
    width: 100%;
    padding-left: rem(56);
    padding-right: rem(56);
    box-sizing: border-box;
    .van-cell::after{
      right: 0;
      left: 0;
    }
    .van-cell{
      background-color: #FFFFFF;
      padding-left: rem(22);
      padding-right: 10px;
      height: rem(96);
      margin-bottom: rem(24);
      border-radius: rem(15);
      &:last-child::after{
        display: block;
      }
      ::v-deep{
        .van-icon-arrow{
          display: none;
        }
        .van-cell__title,.van-cell__value{
          line-height: 32.125px;
        }
        .van-field__label{
          font-size: rem(30);
          color: #333333;
          width: rem(180);
          white-space: nowrap;  /* 强制不换行 */
        }
        input,textarea{
          color: #333333;
          font-size: rem(30);
        }
        input::placeholder,textarea::placeholder{
          color: #cccccc;
        }
      }

    }
    .order-btn{
      margin-top: rem(49);
      width: rem(638);
      height: rem(96);
      border-radius: 10px;
      background-image: -moz-linear-gradient( 90deg, rgb(255,247,152) 0%, rgb(248,212,25) 100%);
      background-image: -webkit-linear-gradient( 90deg, rgb(255,247,152) 0%, rgb(248,212,25) 100%);
      background-image: -ms-linear-gradient( 90deg, rgb(255,247,152) 0%, rgb(248,212,25) 100%);
      box-shadow: 0px 6px 0px 0px rgba(218, 176, 7, 0.004);
      background-color: #FFFFFF;
      color: #9f0e12;
      font-size: rem(32);
      text-align: center;
      line-height: rem(96);
    }
  }

  .van-field-t-div{
    width: 92px;
    height: 32px;
    background-color: #909399;
    img{
      width: 92px;
      height: 32px;
    }
  }
}
</style>
